<div class="container">
    <div class="row">
        <div class="col-12" style="width:2550px">
            <app-mi-invoice-header [miHeaderdetail]="miPrelimData.miHeader"></app-mi-invoice-header>
                <div style="margin-top:30px;">
                <app-mi-invoice-billing-lines [miBillingLines]="miPrelimData.miBillingLines"></app-mi-invoice-billing-lines>
            </div>
            <app-mi-invoice-footer [miFooterData]="miPrelimData.miFooter"></app-mi-invoice-footer>
             <app-mi-total-test></app-mi-total-test>
        </div>
    </div>
</div>


